import { Component, OnInit, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../core/environment';

interface GuestScanResult {
  allowed: boolean;
  message: string;
  direction?: string;
  guestName?: string;
  status?: string;
}

@Component({
  selector: 'app-guest-scan',
  standalone: true,
  template: `
    <main class="guest-scan-page">
      <section class="guest-scan-card" [class.good]="result()?.allowed" [class.bad]="result() && !result()?.allowed">
        <img src="assets/perks-logo.svg" alt="PERKS Sports Academy">
        <span>{{ loading() ? 'Scanning Pass' : result()?.allowed ? 'Entry Updated' : 'Scan Blocked' }}</span>
        <h1>{{ loading() ? 'Please wait...' : result()?.message }}</h1>
        @if (result()?.guestName) {
          <p>{{ result()?.guestName }} | {{ result()?.direction }} | {{ result()?.status }}</p>
        }
      </section>
    </main>
  `
})
export class GuestScanComponent implements OnInit {
  private readonly http = inject(HttpClient);
  private readonly route = inject(ActivatedRoute);
  readonly loading = signal(true);
  readonly result = signal<GuestScanResult | null>(null);

  ngOnInit(): void {
    const cardNumber = this.route.snapshot.paramMap.get('cardNumber') ?? '';
    this.http.post<GuestScanResult>(`${environment.apiUrl}/guest-bookings/scan/${encodeURIComponent(cardNumber)}`, {}).subscribe({
      next: (result) => {
        this.result.set(result);
        this.loading.set(false);
      },
      error: (error) => {
        this.result.set(error.error ?? { allowed: false, message: 'Unable to scan guest pass.' });
        this.loading.set(false);
      }
    });
  }
}
